import { useEffect, useState } from "react";
import {
    FaBox,
    FaCalendarCheck,
    FaClock,
    FaExchangeAlt,
    FaFileAlt,
    FaSignOutAlt,
    FaTicketAlt,
    FaUser,
    FaWindowClose
} from "react-icons/fa";
import "./PortalSideBar.css";
import { useNavigate } from "react-router-dom";
import { _single } from "../../../../core/services/dataBean/EntityCatalog";
import { eliminarCookies } from "../../../../utils/helpers";
import { usePortal } from "../../hook/usePortalState";
import { configPortal } from "../../../../configPortal";

interface Props {
    setIsLogged: any;
}

export const PortalSideBar = ({ setIsLogged }: Props) => {

    const [user, setUser] = useState<any>({});
    const { setViewMenu, viewMenu, isMovil } = usePortal();
    const logo = configPortal.IMG_SOURCE ?? _single.getIMGLogo();

    const navigate = useNavigate();

    useEffect(() => {
        setUser(_single.getAccount());
    }, []);

    const logout = () => {
        navigate("/");
        sessionStorage.clear();
        eliminarCookies();
        setIsLogged(false);
        window.location.reload();
    };

    const navigateTO = (parameter: string) => {
        navigate(`/portal/home/${parameter}`);
    };

    const buttonAction = (navigation: string) => {
        navigateTO(navigation);
        if (isMovil) setViewMenu(false);
    };

    const menusByPortal: Record<number, Array<{ key: string; label: string; icon: JSX.Element }>> = {
        1: [
            { key: "personal-info", label: "Información Personal", icon: <FaUser className="icon" /> },
            { key: "credit-lines", label: "Líneas de Crédito", icon: <FaExchangeAlt className="icon" /> },
            { key: "requests", label: "Bandejas de Solicitudes", icon: <FaFileAlt className="icon" /> },
            { key: "products", label: "Mis Productos", icon: <FaBox className="icon" /> },
        ],
        
        2: [
            { key: "personal-account-info", label: "Mi Perfil", icon: <FaUser className="icon" /> },
            { key: "services", label: "Servicios disponibles", icon: <FaClock className="icon" /> },
            { key: "init-turn", label: "Solicitar Agendamiento", icon: <FaTicketAlt className="icon" /> },
            { key: "active-turn", label: "Agendamientos Activos", icon: <FaCalendarCheck className="icon" /> },
            { key: "history-turn", label: "Historial de Agendamientos", icon: <FaClock className="icon" /> },
        ],
        
        3: [
            { key: "personal-account-info", label: "Mi Perfil", icon: <FaUser className="icon" /> },
            { key: "mi-contract", label: "Contratos", icon: <FaBox className="icon" /> },
            { key: "requests", label: "Bandejas de Solicitudes", icon: <FaFileAlt className="icon" /> },
        ]
    };

    const portalMenus: number = configPortal.MENUS_PORTAL ?? 1;

    const currentMenu = menusByPortal[portalMenus] ?? [];

    return (
        <aside className="portal_sidebar">

            <div className="sidebar-header row d-flex justify-content-center">
                <img
                    src={`./assets/images/customizables/${logo ?? "logo-amc-negro.png"}`}
                    alt="Company Logo"
                    className="img-fluid side_Img"
                />
                {user.IDAccount && (
                    <p className="greeting">
                        HOLA!, <span>{user.Name1}</span>
                    </p>
                )}
            </div>

            <ul className="sidebar-menu">
                {currentMenu.map((menu) => (
                    <li key={menu.key} onClick={() => buttonAction(menu.key)}>
                        {menu.icon} {menu.label}
                    </li>
                ))}
            </ul>

            <div className="sidebar-footer">
                <ul className="sidebar-menu">
                    <li onClick={() => logout()}>
                        <FaSignOutAlt className="icon" /> Cerrar sesión
                    </li>

                    {isMovil && (
                        <li onClick={() => setViewMenu(!viewMenu)}>
                            <FaWindowClose className="icon" /> Cerrar Menú
                        </li>
                    )}
                </ul>
            </div>
        </aside>
    );
};
